<template>
  <div class="search">
    <div class="index-header">
      <img class="logo" src="@/assets/img/company.png"/>
      <div class="search" @click="searchPage">
        <van-icon name="sousuo"></van-icon>
        <span>搜索职位/公司…</span></div>
    </div>
    <van-dropdown-menu class="filter" active-color="#1C54CF">
      <van-dropdown-item title="区域" v-model="form.enterpriseAreaId" :options="areaList" @change="changeArea"/>
      <van-dropdown-item title="选择行业" @open="showIndustrySelect"/>
      <van-dropdown-item v-model="form.recommend" :options="recommendList" @change="selectRecommendStatus"/>
      <van-dropdown-item title="智能筛选" @open="showFilterPop"/>
    </van-dropdown-menu>

    <van-list
      v-model="status.loading"
      :finished="status.finished"
      finished-text="没有更多了"
      @load="next()"
    >
    <ul class="company-list-simple">
      <template v-for="item in companySimple">
        <li :key="item.index" @click="companyDetail(item.id)" v-if="item.positionCnt != 0">
          <img v-if="item.enterpriseLogoUrl" :src="item.enterpriseLogoUrl + '?imageMogr2/auto-orient/thumbnail/100x100'"/>
          <img v-else src="../../../../assets/img/logo2.png"/>
          <div class="detail-info">
            <h3>{{item.enterpriseName}}</h3>
            <ul class="feature">
              <li>{{ item.enterpriseTypeName }}</li>
              <li>{{ item.enterpriseTradesName }}</li>
              <li>{{ item.personnelSize }}</li>
            </ul>
            <div class="jobs">
              <div class="place">{{item.enterpriseAreaName}}</div>
              <div class="num">
                在招职位 <span>{{item.positionCnt}}</span> 个
              </div>
            </div>
          </div>
        </li>
      </template>
    </ul>
    </van-list>

    <!--选择行业-->
    <transition name="van-fade">
      <div class="job-pop" v-show="industrySelect" style="padding-bottom: 100px;">
        <!-- <div class="pop-header">
          <van-icon @click="industrySelect = false" name="fanhui"></van-icon>
          选择行业
        </div> -->
        <van-search v-model="searchJobType" placeholder="请输入关键词搜索您的行业类型" @search="onSearchJobType"/>
        <van-tree-select
          @click-nav="clickNav"
          @click-item="clickItem"
          :items="jobTypeList"
          height="100%"
          :active-id.sync="activeId"
          :main-active-index.sync="activeIndex"
        >
          <template slot="content">
            <ul class="right-content">
              <li 
                v-if="jobTypeChildrenList.length"
                @click="clickItemAll"
                :class="{'select':jobTypeList.length && Object.keys(selectedMap[jobTypeList[activeIndex].id] || {}).length && jobTypeList[activeIndex].isParent}"
              >全部</li>
              <li v-for="(item,index) in jobTypeChildrenList" :key="item.id"
                  :class="{'select':activeId.indexOf(item.id)>-1}"
                  @click="clickItem(item)"> {{item.text}}
              </li>
            </ul>
          </template>
        </van-tree-select>
        <div class="fixed-bottom">
          <div class="selected">
            <span>已选：</span>
            <ul>
              <template v-for="item in selectedLabelList">
                <li v-if="item.label" :key="item.id" @click="clickItem(item,'close')">{{item.text}}</li>
              </template>
            </ul>
          </div>
          <div class="btn-cont">
            <van-button type="primary" class="btn-gray" color="#EEEFF1" @click="clearJobType" round>清 除</van-button>
            <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)"
                        @click="submitJobType" round>确
              定
            </van-button>
          </div>
        </div>
      </div>
    </transition>
    <!--智能筛选-->
    <transition name="fade">
      <div class="filter-cont" v-show="filterPop">
        <div class="pop-header">
          <van-icon name="closed" @click="hiddenPop"></van-icon>
          <h2>智能筛选</h2>
        </div>
        <h3>公司规模
          <small></small>
        </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in personnelSizeList" :key="index" :class="{checked:item.dictKey==form.personnelSize}"
              @click="selectPersonnelSize(item.dictKey)"><span>{{item.dictValue}}</span></li>
        </ul>
        <h3>公司性质
          <small></small>
        </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in entTypeList" :key="index" :class="{checked:item.dictKey==form.enterpriseType}"
              @click="selectEntType(item.dictKey)"><span>{{item.dictValue}}</span></li>
        </ul>
        <div class="fixed-bottom">
          <van-button type="primary" class="btn-gray" color="#EEEFF1" @click="clearEntSearch" round>清 除</van-button>
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)"
                      @click="submitEntSearch" round>确 定
          </van-button>
        </div>
      </div>
    </transition>
    <navBar></navBar>
  </div>
</template>

<script>
  import navBar from '../components/navbar'

  export default {
    name: 'companyList',
    components: {
      navBar
    },
    data() {
      return {
        n: 0,
        year: 0,
        form: {
          current: 0,
          size: 10,
          recommend: "",
          personnelSize: "",
          enterpriseTradesId: "",
          enterpriseAreaId: "0",
          enterpriseType: "",
        },
        status: {
          loading: false,
          finished: false
        },
        industrySelect: false,
        filterPop: false,
        recommendRecruitment: '仅看推荐',
        jobTypeList: [],
        allJobTypeList: [],
        jobTypeChildrenList: [],
        recommendList: [
          {text: "所有", value: ""},
          {text: "仅看推荐", value: "1"},
          {text: "仅看非推荐", value: "0"},
        ],
        areaList: [
          {text: '区镇街道', value: '01'},
          {text: '全嘉定', value: 'a'},
          {text: '马陆镇', value: 'b'},
          {text: '江桥', value: 'c'},
          {text: '南翔镇', value: 'd'},
          {text: '销徐行量排序', value: 'e'},
          {text: '外冈', value: 'f'},
          {text: '安亭', value: 'g'}
        ],

        //选中的行业名称
        selectedLabelList: [],
        //选中的行业集合
        selectedMap: {},
        searchJobType: '',
        activeId: [],
        activeIndex: 0,
        //企业列表
        companySimple: [],
        //企业类型
        entTypeList: [],
        //企业规模
        personnelSizeList: [],
        salaryList: ['不限', '3000以下', '3000-4500', '3000以下', '3000以下', '3000以下', '3000以下', '3000以下', '3000以下'],
        seniority: ['不限', '一年以下', '1-2年', '3-5年', '6-7年', '8-10年', '10年以上'],
        educationList: [
          {education: '不限', check: true},
          {education: '初中及以下', check: false},
          {education: '中专/中技', check: false},
          {education: '高中', check: false},
          {education: '大专', check: false},
          {education: '本科', check: false},
          {education: '硕士', check: false},
          {education: '博士', check: false}
        ]
      }
    },
    methods: {
      changeArea(){
        this.loadFirstPage();
      },
      selectRecommendStatus(){
        this.loadFirstPage();
      },
      /**
       * 清除已选行业
       */
      clearJobType() {
        this.activeId = [];
        this.selectedLabelList = [];
        this.selectedMap = {};

        // this.industrySelect = false;
        // this.form.enterpriseTradesId = ''
        // this.loadFirstPage()
      },
      /**
       * 确定行业
       */
      submitJobType() {
        console.log(this.jobTypeList[this.activeIndex])
        console.log(this.activeId)
        console.log(this.jobTypeChildrenList)

        // let bl = this.jobTypeChildrenList.some((item,index)=>{
        //   return this.activeId.some((o)=>{
        //     return item.id == o
        //   })
        // })

        // let array = JSON.parse(JSON.stringify(this.activeId))

        // this.selectedLabelList = this.selectedLabelList.filter(item=>{
        //   return !item.isParent
        // })

        // if(!bl){
        //   this.selectedLabelList.push({
        //     id:this.jobTypeList[this.activeIndex].id,
        //     text: this.jobTypeList[this.activeIndex].text,
        //     isParent: true
        //   })
        //   for(let o of this.jobTypeChildrenList){
        //     array.push(o.id)
        //   }
        // }

        // for(let i of this.jobTypeList){
        //   if(i.isParent){

        //   }
        // }

        let array = JSON.parse(JSON.stringify(this.activeId))
        this.form.enterpriseTradesId = array.join(",")

        console.log(this.form.enterpriseTradesId )

        this.industrySelect = false;
        this.loadFirstPage()
      },
      loadFirstPage(){
        this.form.current=1;
        this.companySimple=[];
        this.onload();
      },

      /**
       * 树形列表选择左侧
       */
      clickNav(e) {
        this.jobTypeChildrenList = []
        this.loadTrades(this.jobTypeList[e].id);
      },
      clickItemAll(){
        // 清除已选择的子项
        // this.clearJobType()
        for(let i of this.jobTypeChildrenList){
          for(let j of this.activeId){
            if(i.id == j){
              // this.selectedMap[j]
              delete this.selectedMap[j]
              
              this.selectedLabelList = this.selectedLabelList.filter(item=>{
                return item.id != j;
              })
              this.activeId = this.activeId.filter(item=>{
                return item != j;
              })
            }
          }
        }
        console.log(this.activeId.length)
        // this.clearJobType()
        if (this.selectedMap.hasOwnProperty(this.jobTypeList[this.activeIndex].id)) {
          delete this.selectedMap[this.jobTypeList[this.activeIndex].id];
          this.jobTypeList[this.activeIndex].isParent = false
          
        } else {
          this.jobTypeList[this.activeIndex].isParent = true
          this.selectedMap[this.jobTypeList[this.activeIndex].id] = {
            id: this.jobTypeList[this.activeIndex].id,
            text: this.jobTypeList[this.activeIndex].text,
            isParent: true,
            label: true

          };
          for(let i of this.jobTypeChildrenList){
            this.selectedMap[i.id] = {
              ...i,
              id: i.id,
              text: i.text,
              isParent: false,
              label: false
            };
          }
        }

        let temp = [];
        let ids = [];
        for (let o in this.selectedMap) {
          temp.push({
            id: this.selectedMap[o].id,
            text: this.selectedMap[o].text,
            label: this.selectedMap[o].label
          });
          if(!this.selectedMap[o].isParent){
            ids.push(this.selectedMap[o].id);
          }
        }
        this.selectedLabelList = temp;
        this.activeId = ids;

      },
      clickItem(e,type) {
        console.log(e)
        if(this.jobTypeList[this.activeIndex].isParent){
          // delete this.selectedMap[this.jobTypeList[this.activeIndex].id];
          this.jobTypeList[this.activeIndex].isParent = false
          // console.log("父")
          // for(let i in this.activeId){
          //   if(this.activeId[i].id == this.jobTypeList[this.activeIndex].id){
          //     this.activeId.splice(i,1)
          //   }
          // }
          if(type == 'close'){
            for(let id of Object.keys(this.selectedMap)){
              if(this.jobTypeList[this.activeIndex].id == this.selectedMap[id].parentId){
                delete this.selectedMap[id]
              }
            }
          }
          
          
        }
        

        if (this.selectedMap.hasOwnProperty(e.id)) {
          delete this.selectedMap[e.id];
        } else {
          // if(this.selectedLabelList.length>=3){
          //   this.toast('最多选择三个行业')
          //   return;
          // }
          console.log(e,'22')
           this.selectedMap[e.id] = e;
        }

        // for(let i of this.jobTypeChildrenList){
        //   for(let j of this.activeId){
        //     if(i.id == j){
        //       // this.selectedMap[j]
              
        //     }
        //   }
        // }


        let temp = [];
        let ids = [];
        for (let o in this.selectedMap) {
          if(this.selectedMap[o].label == undefined){
            this.selectedMap[o].label = true
          }
          temp.push({
            id: this.selectedMap[o].id,
            text: this.selectedMap[o].text,
            label: this.selectedMap[o].label
          });
          ids.push(this.selectedMap[o].id);
        }
        this.selectedLabelList = temp;
        this.activeId = ids;

        // 判断子项是否全部选中
        let isAll = this.jobTypeChildrenList.every(item=>{
          return this.activeId.some(o=>{
            return o == item.id
          })
        })
        console.log(isAll)
        if(type != 'close'){
          if(isAll){
            for(let i of this.jobTypeChildrenList){
              for(let j of this.selectedLabelList){
                if(i.id == j.id){
                  this.selectedMap[j.id].label = false
                  j.label = false

                }
              }
            }
            this.jobTypeList[this.activeIndex].isParent = true
            this.selectedMap[this.jobTypeList[this.activeIndex].id] = {
              id: this.jobTypeList[this.activeIndex].id,
              text: this.jobTypeList[this.activeIndex].text,
              isParent: true,
              label: true
            };
            this.selectedLabelList = this.selectedLabelList.filter(item=>{
              return item.id != this.jobTypeList[this.activeIndex].id
            })
            this.selectedLabelList.push({
              id: this.jobTypeList[this.activeIndex].id,
              text: this.jobTypeList[this.activeIndex].text,
              label: true
            })

          }else{
            for(let i of this.jobTypeChildrenList){
              for(let j of this.selectedLabelList){
                if(i.id == j.id){
                  // this.selectedMap[j]
                  this.selectedMap[j.id].label = false
                  j.label = true
                }
              }
            }
          }
        }



      },
      next(){
        this.form.current++;
        this.onload();
      },
      onload() {
        let submitData = JSON.parse(JSON.stringify(this.form))
        if(submitData.enterpriseAreaId == "0"){
          submitData.enterpriseAreaId = ""
        }

        this.module.api.entList({
          params: submitData,
          success: (data) => {
            this.companySimple=this.companySimple.concat(data.records);
            this.status.finished = this.form.current >= data.pages
            this.status.loading = false
          }
        })
      },
      /**
       * 获取行业列表
       */
      loadTrades(pid) {
        this.module.api.trades({
          params: {parentId: pid},
          success: (records) => {
            let temp = [];
            for (let i = 0; i < records.length; i++) {
              let item = records[i];
              if(pid == 0){
                item.isParent = false
              }
              temp.push(this.formatterTreeData(item));
            }
            if (pid == 0) {
              this.jobTypeList = temp;
              this.allJobTypeList = temp;
            } else {
              // this.jobTypeList[this.activeIndex].children = temp;
              this.jobTypeChildrenList = temp;
            }
          }
        })
      },
      /**
       * 获取区域列表
       */
      loadArea(pid,grade) {
        this.module.api.area({

          params: {parentId: pid,grade},
          success: (records) => {
            let list = [];
            for (let i = 0; i < records.length; i++) {
              list.push({
                value: records[i].id,
                text: records[i].title
              })
            }
            this.areaList = list;
            list.unshift({
              text:"全部",
              value:"0"
            })
            console.log(list)
          }
        })
      },
      /**
       * 清除智能筛选数据
       */
      clearEntSearch() {
        this.form.personnelSize = "";
        this.form.enterpriseType = "";
      },

      /**
       * 提交智能筛选
       */
      submitEntSearch() {
        this.filterPop = false;
        this.loadFirstPage()
      },
      /**
       * 格式化树形列表数据
       */
      formatterTreeData(item) {
        let data = {
          id: item.id,
          parentId: item.parentId,
          hasChildren: item.hasChildren,
          key: item.key,
          text: item.title
        }
        return data;
      },
      /**
       * 加载公司性质
       */
      loadEntType() {
        this.module.api.bizDict({
          params: {code: "ent_info_type"},
          success: (records) => {
            this.entTypeList = records;
          }
        })
      },

      /**
       * 加载公司规模
       */
      loadPersonnelSize() {
        this.module.api.bizDict({
          params: {code: "personnel_size"},
          success: (records) => {
            this.personnelSizeList = records;
          }
        })
      },
      onClickLeft() {
        this.$router.go(-1)
      },
      searchPage() {
        this.$router.push({name: 'searchCompany'})
      },
      companyDetail(id) {
        this.$router.push({name: 'companyDetail', query: {id}})
      },
      selectSalary(index) {
        this.n = index
      },
      selectPersonnelSize(value) {
        this.form.personnelSize = value
      },
      selectEntType(value) {
        this.form.enterpriseType = value
      },
      selectEducation(idx) {
        var check = this.educationList[idx].check
        this.educationList[idx].check = !check
      },
      hiddenPop() {
        this.filterPop = false
      },
      showFilterPop() {
        this.filterPop = true
      },
      /**
       * 搜索行业
       */
      onSearchJobType() {

        if (this.searchJobType == "") {
          this.jobTypeList = this.allJobTypeList
          return;
        }
        this.jobTypeList = [];
        this.jobTypeChildrenList = [];
        for (let i = 0; i < this.allJobTypeList.length; i++) {
          let item = this.allJobTypeList[i];
          if (item.text.indexOf(this.searchJobType) > -1) {
            this.jobTypeList.push(item);
          }
        }
        if (this.jobTypeList.length > 0) {
          this.activeIndex = 0;
          this.loadTrades(this.jobTypeList[0].id)
        }
      },

      showIndustrySelect() {

        this.loadTrades(this.jobTypeList[this.activeIndex].id);
        this.industrySelect = true;
      }
    },
    mounted() {
      this.loadPersonnelSize();
      this.loadEntType();
      this.loadTrades(0);
      //嘉定区 id
      this.loadArea(0,2);
    },
    // 路由离开
    beforeRouteLeave(to,from,next){
      if(to.name == 'companyDetail' && from.name == 'companyList'){
        from.meta.keepAlie = true;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        localStorage.setItem('companyScrollTop',scrollTop)
      }else{
        from.meta.keepAlie = false;
        localStorage.setItem('companyScrollTop',0)
      }
      next()
    },
    // 路由进入
    beforeRouteEnter(to,from,next){
      var position1 = 0;
      if(to.name == 'companyList' && from.name == 'companyDetail'){
        position1 = parseInt(localStorage.getItem('companyScrollTop'))
      }
      next(vm=>{
        // vm.$set(vm.encyclopedia[index],'viewsNum',vm.encyclopedia[index].viewsNum+1)
        var time = setInterval(() => {
          document.documentElement.scrollTop = position1
          document.body.scrollTop = position1
          vm.loading = false
          clearInterval(time)
        }, 0);
      })
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .van-popup {
    border-radius: 0 0 10px 10px;
    min-height: auto;
  }

  /deep/ .filter {
    background: #1C54CF;
    width: 100%;
    padding: 0;

    .van-dropdown-menu__bar {
      width: 100%;
      background: none;

      .van-ellipsis {
        color: #CCD9F5;
      }
    }

    .van-cell__value {
      display: none;
    }

    .van-cell__title {
      text-align: center;
    }
  }

  .index-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    flex-direction: row;
    background: #1C54CF;

    .logo {
      width: 104px;
      height: 24px;
      line-height: 1;
    }

    .search {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      flex: 1;
      color: #fff;
      height: 30px;
      border-radius: 50px;
      background: rgba(255, 255, 255, .3);
      margin-left: 16px;

      span {
        font-size: 12px;
        margin-left: 10px;
      }
    }
  }

  .search-condition {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 16px 20px;

    ul {
      display: flex;
      align-items: center;

      li {
        color: #B7BABF;
        font-size: 12px;
        padding: 6px 12px;
      }

      &.condition {
        .select {
          background: #F5F2EF;
          color: #2E3133;
          border-radius: 50px;
        }
      }

      &.pop-select {
        li {
          position: relative;

          &:after {
            content: '\e629';
            position: absolute;
            right: -6px;
            top: 8px;
            font-family: van-icon;
          }
        }
      }
    }
  }

  .company-list-simple {
    margin-left: 0;
    margin-right: 0;

    & > li {
      border-bottom: 8px solid #F7F7F7;
      padding-bottom: 16px;
      padding-left: 16px;
      padding-right: 16px;
      align-items: flex-start;

      &:last-child {
        border-bottom: 0;
      }

      .detail-info {
        h3 {
          font-size: 16px;
          margin-bottom: 8px;
        }
      }

      .jobs {
        color: #3A3A3A;
        margin-left: -16px;
        font-size: 14px;

        &:after {
          content: '\e603';
          font-size: 10px;
          position: absolute;
          right: -10px;
          top: 50%;
          margin-top: -5px;
          font-family: van-icon;
          color: #C6CDD6;
        }

        .num {
          color: #606060
        }
      }
    }
  }

  .fixed-bottom {
    padding: 10px 16px 20px;

    button {
      &.btn-gray {
        flex: 1;
        margin-right: 15px;
      }

      &.btn-blue {
        flex: 2;
      }
    }
  }
  .job-pop {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    background: #fff;
    top: 0;
    z-index: 999;

    /deep/.right-content {
      li {
        margin: 16px;
        position: relative;
        padding:2px 0;
        &.select {
          color: #2F72F6;
          &:after {
            content: "\E607";
            font-family: van-icon;
            position: absolute;
            right: 10px;
            color: #2F72F6;
            top: 50%;
            transform: translate(0, -50%);
          }
        }
      }
    }

    .fixed-bottom {
      z-index: 9999;
      flex-direction: column;

      .btn-cont {
        width: 100%;
        display: flex;
        padding: 0;

        button {
          &.btn-gray {
            flex: 1;
            margin-right: 10px;
          }

          &.btn-blue {
            flex: 3;
          }
        }
      }


      .selected {
        width: 100%;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        white-space: nowrap;

        span {
          color: #B6B9BF;
          margin-right: 5px;
        }

        ul {
          display: flex;
          overflow: auto;

          &::-webkit-scrollbar {
            display: none;
          }

          li {
            background: #E4EBFB;
            border: 1px solid #4469E3;
            color: #4469E3;
            padding: 2px 24px 2px 10px;
            border-radius: 50px;
            margin: 0 3px;
            font-size: 12px;
            position: relative;

            &:after {
              content: '\e926';
              position: absolute;
              font-family: van-icon;
              top: 54%;
              right: 8px;
              transform: translate(0, -50%);
            }
          }
        }
      }
    }

    .pop-header {
      display: flex;
      justify-content: center;
      height: 50px;
      border-bottom: 1px solid #eee;
      align-items: center;
      color: #303132;
      position: relative;
      font-size: 16px;
      background: #fff;

      i {
        position: absolute;
        left: 20px;
        top: 50%;
        margin-top: -8px;
      }
    }

    h2 {
      padding: 22px 16px 0;
      color: #333;
      font-size: 22px;
      font-weight: bold;
      background: #fff;
    }

    .van-search {
      padding-left: 6px;
      padding-right: 6px;
      padding-bottom: 10px;

      .van-search__content {
        background: rgba(231, 236, 243, .3);
        border-radius: 50px;
        height: 40px;

        .van-cell {
          padding: 0 6px;
          line-height: 40px;

          /deep/ input {
            padding-left: 6px;
            padding-top: 2px;

            &::placeholder {
              color: #C9CCD2
            }
          }

          /deep/ i {
            color: #E7ECF3;
          }
        }
      }
    }

    .jobs {
      display: flex;
      flex-direction: column;

      li {
        padding: 20px 0;
        margin: 0 20px;
        border-bottom: 1px solid #eee;
        position: relative;
        font-size: 16px;
        color: #5C5D5F;

        &.checked {
          color: #2F72F6;
        }

        &:after {
          content: '\e603';
          position: absolute;
          right: 20px;
          top: 50%;
          margin-top: -7px;
          font-size: 16px;
          font-family: van-icon;
          color: #929292
        }

      }
    }

    &.job-pop2 {
      background: rgba(0, 0, 0, .7);

      /deep/ .van-tree-select {
        margin-left: 60px;
      }
    }
  }

  /deep/ .van-tree-select {
    .van-sidebar-item--select::before {
      background: #2F72F6;
    }

    .van-sidebar-item--select, .van-tree-select__item--active {
      color: #2F72F6
    }
  }

  /deep/ .van-tree-select {

    activeItem {
      color: #1e9fff;
    }
  }
</style>
